import { IMapWidgetFormGroupSettings } from '../../../map-widget-settings/map-widget-settings.interface'
import { IMapWidgetPermissions } from '../../../../shared/interfaces/map-widget-permission.interface'
import { INotification } from 'ngsild-connector'
import { INgsiEntity } from '../interfaces/ngsi-entity.interface'
import { INgsiIdDesignPattern } from '../helpers/ngsild.constants'

export const plannedPathType: string = `PlannedPath`;
const plannedPathOwner: string = `CAPTN`;

export const ngsiPlannedPathPattern: Omit<INgsiIdDesignPattern, 'idPattern'> = {
  prefix: `urn:ngsi-ld:`,
  type: plannedPathType,
  owner: plannedPathOwner
}

export const grantEntityPassage = (
  notification: INotification,
  appPluginWidgetSettings: IMapWidgetFormGroupSettings,
  widgetPermissions: IMapWidgetPermissions
): boolean => {
  const settings = appPluginWidgetSettings;
  if (settings?.entities) {
    return widgetPermissions.plannedPathDataEnabled &&
      allowDisplayOfEntity(settings, notification.data[0]);
  } else {
    return false;
  }
}

export const allowDisplayOfEntity =
  (
    settings: IMapWidgetFormGroupSettings,
    entity: INgsiEntity
  ): boolean => {
  return entity.type === plannedPathType && settings.enablePlannedPath;
}
